import { createAction, props } from '@ngrx/store';

export const setContext = createAction('[Flow] Set Context', props<{ context: string }>());

export const clearContext = createAction('[Flow] Clear Context', props<{ newContext: string }>());

export const preserveContext = createAction(
    '[Flow] Preserve Context',
    props<{ context: string }>()
);

export const noop = createAction('[Flow] Noop');

export const resetContext = createAction('[Flow] Reset Context');
